import cmsPage from 'api/definitions/cms-page';

import {
  GET_CMS_PAGE_LOADING,
  GET_CMS_PAGE_SUCCESS,
  GET_CMS_PAGE_FAILURE,
  GET_CMS_PAGE_NOT_FOUND,
} from 'redux/modules/cms-page/actions/types';

import { EXPERIENCE_FRAGMENT_SCHEMA } from 'redux/schemas';
import { goToInternalOrExternalLocation } from 'utils/go-to-internal-or-external-location';

export default (contentUrl, customerId) => dispatch => {
  const notFoundStatuses = [400, 404];

  return dispatch({
    apiCall: cmsPage.put({
      body: {
        contentUrl: `/${contentUrl}`,
        customerId,
        customerSearchRequest: {
          queryParams: {},
        },
      },
      endpoint: contentUrl,
      iHandleStatusCodes: notFoundStatuses,
    }),
    contentUrl,
    types: [GET_CMS_PAGE_LOADING, GET_CMS_PAGE_SUCCESS, GET_CMS_PAGE_FAILURE],
    schema: EXPERIENCE_FRAGMENT_SCHEMA,
  })
    .then(result => {
      if (result.redirectUrl) {
        return goToInternalOrExternalLocation(result.redirectUrl);
      }

      return result;
    })
    .catch(error => {
      if (notFoundStatuses.includes(error.status)) {
        dispatch({ type: GET_CMS_PAGE_NOT_FOUND });
      }
    });
};
